import dayjs from 'dayjs'
import sha256 from 'crypto-js/sha256'

export const getDeviceInfo = () => {
  // 设备信息来源 http://mapi.youbora.com:8081/devices
  // https://juejin.cn/post/6844903874113830920
  const ua = navigator.userAgent.toLowerCase()
  const testUa = (regexp) => regexp.test(ua)
  if (testUa(/windows|win32|win64|wow32|wow64/g)) {
    return {
      id: 2,
      name: 'PC( Windows )',
      code: 'PCWindows'
    }
  } else if (testUa(/macintosh|macintel/g)) {
    return {
      id: 3,
      name: 'PC( MAC )',
      code: 'PCMac'
    }
  } else if (testUa(/x11/g)) {
    return {
      id: 1,
      name: 'PC( Linux )',
      code: 'PCLinux'
    }
  } else if (testUa(/android|adr/g)) {
    return {
      id: 11,
      name: 'Android',
      code: 'Android'
    }
  } else if (testUa(/ios/g)) {
    return {
      id: 48,
      name: 'iOS',
      code: 'iOS'
    }
  } else {
    return {
      id: '',
      name: '',
      code: ''
    }
  }
}

// 生成n位数字字母混合字符串
export function generateMixed(n) {
  const chars = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z'
  ]
  let res = ''
  for (let i = 0; i < n; i++) {
    const id = Math.floor(Math.random() * 36)
    res += chars[id]
  }
  return res
}

/**
 * 复制字符串到粘贴板
 * @param {string} str 将要复制的字符串
 */
export const copyString = (str) => {
  const copyDom = document.createElement('textarea')
  copyDom.value = str
  document.body.appendChild(copyDom)
  return new Promise((resolve) => {
    setTimeout(() => {
      try {
        copyDom.select()
        document.execCommand('Copy')
        document.body.removeChild(copyDom)
        resolve(true)
      } catch (err) {
        resolve(false)
      }
    }, 100)
  })
}

// 传入一个整数参数，函数处理成多少k的形式，且保留一位小数点
export const num2k = (num) => {
  if (num < 0) return 0
  let _num = num + ''
  // 若数字是四位数以下没到千位的，就直接返回
  if (_num.length < 4) return num
  else {
    // 获取倒数第四个数及之前/去掉后三个数/千位数之前
    let num1 = _num.substring(0, _num.length - 3)
    // 获取百位数
    let num2 = _num.substring(_num.length - 3, _num.length - 2)
    // 设置一个小数点
    let point = '.'
    // 完事后若百位数是0的话需要省略掉百位，及小数点
    if (num2 == 0) {
      num2 = ''
      point = ''
    }
    // 最后拼接千位数之前、小数点、百位数、和一个k
    if (num > 999000) return '999k+'
    return num1.concat(point, num2, 'k')
  }
}

/**
 * 过滤特殊字符
 * @param {*} stg
 * @returns
 */
export function filterSpecial(stg = '') {
  try {
    // 保留：\p{L}（所有字母，包括各种语言）、\p{N}（所有数字）、下划线 _（TC-1630 SEO 要求）
    // 替换：其他所有字符（包括空格、标点、特殊符号等，emoji范围）
    // emoji 范围：U+1F300-U+1F9FF, U+2600-U+26FF, U+2700-U+27BF, U+1F600-U+1F64F, U+1F680-U+1F6FF, U+1F900-U+1F9FF, U+1FA00-U+1FAFF
    return stg.replace(
      /[^\p{L}\p{N}_\u{1F300}-\u{1F9FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FAFF}]/gu,
      '-'
    )
  } catch (error) {
    return stg
  }
}

/**
 * 返回日期相对时间
 * @param {number} time
 * @returns string
 */
export function toReativeTime(time) {
  if (time && dayjs(time).isValid()) {
    const unix = dayjs.unix(time)
    const now = dayjs()
    if (now.diff(unix, 's') < 60) {
      return `${now.diff(unix, 's')}秒前`
    } else if (now.diff(unix, 'm') < 60) {
      return `${now.diff(unix, 'm')}分鐘前`
    } else if (now.diff(unix, 'h') < 24) {
      return `${now.diff(unix, 'h')}小時前`
    } else {
      return unix.format('YYYY-MM-DD HH:mm')
    }
  } else {
    return ''
  }
}

export function toISOString(time) {
  if (time && dayjs(time).isValid()) return dayjs(time * 1000)?.toISOString()
  return ''
}

export function isMobileDevice() {
  return (
    !import.meta.env.SSR &&
    (navigator?.userAgentData?.mobile ||
      /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
  )
}

export function setSessionStorage(key, value) {
  sessionStorage.setItem(key, JSON.stringify(value))
}

export function getSessionStorage(key) {
  const value = sessionStorage.getItem(key)
  return JSON.parse(value)
}

/* 判断是否爬虫蜘蛛 */
export function isBot() {
  return (
    !import.meta.env.SSR &&
    /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent.toLowerCase())
  )
}

/* 判斷是否有視頻 */
export function checkVideo(item) {
  if (item?.video_url && item.video_url.length > 0) {
    return true
  }
  if (item?.video_id && item.video_id > 0) {
    return true
  }
  return false
}

export const isSafari = () => {
  const userAgent = navigator.userAgent
  return /Safari/.test(userAgent) && !/Chrome/.test(userAgent)
}

// 获取 Safari 版本号，如果不是 Safari 返回 null
export const getSafariVersion = () => {
  const userAgent = navigator.userAgent
  const isSafariBrowser = /Safari/.test(userAgent) && !/Chrome/.test(userAgent)

  if (!isSafariBrowser) return null

  // 尝试从 User Agent 中提取版本号
  const versionMatch = userAgent.match(/Version\/(\d+)(?:\.(\d+))?/)
  if (versionMatch) {
    const major = parseInt(versionMatch[1], 10)
    const minor = versionMatch[2] ? parseInt(versionMatch[2], 10) : 0
    return { major, minor, full: `${major}.${minor}` }
  }

  return null
}

// 检查是否是 Safari 17 以下版本
export const isSafariBelow17 = () => {
  const version = getSafariVersion()
  if (!version) return false
  return version.major < 17
}

export function getTvbPlayerType(videoType) {
  if (videoType == 2) {
    return 'shaka'
  }
  return 'youtube'
}

/**
 * 从 getAds 返回的 ads_list 中根据屏幕尺寸匹配并提取 Instream 广告尺寸
 * 复用 TvbAds 组件中 size_setting 的匹配逻辑：先按 window.innerWidth/innerHeight
 * 匹配 width/height 范围（0 视为无界限），再在命中项中查找指定 ad_type 的 size
 * @param {Array} adsList - getAds 返回的 ads_list 数组
 * @param {string} adType - 广告类型，默认 'pr'
 * @returns {string} 广告尺寸字符串，如 '1920x1080'
 */
export function getInstreamAdSize(adsList, adType = 'pr') {
  if (!Array.isArray(adsList)) return ''
  const { innerWidth, innerHeight } = window
  for (const item of adsList) {
    // 屏幕尺寸范围匹配（复用 TvbAds 组件逻辑，0 视为无界限）
    const [minWidth, maxWidth] = item.width || []
    const [minHeight, maxHeight] = item.height || []
    const sizeMatched =
      innerWidth >= (minWidth || -Infinity) &&
      innerWidth <= (maxWidth || Infinity) &&
      innerHeight >= (minHeight || -Infinity) &&
      innerHeight <= (maxHeight || Infinity)
    if (!sizeMatched) continue
    const matched = item.size_setting?.find((s) => s.ad_type === adType)
    // size 为 GPT 格式 [[w1, h1], [w2, h2], ...]，多组用 '|' 连接
    if (matched?.size?.length) {
      return matched.size.map(([w, h]) => `${w}x${h}`).join('|')
    }
  }
  return ''
}

/**
 * 判断广告 MediaFile URL 是否为 TVB 内部广告
 * @param {string} url - 广告 MediaFile URL
 * @returns {boolean} 是否为 TVB 内部广告
 */
export function isTvbInHouseAd(url) {
  if (!url || typeof url !== 'string') return false
  const tvbDomains = ['tvb.com', 'cdn.tvb.com', 'ads.cdn.tvb.com']
  return tvbDomains.some((domain) => url.includes(domain))
}

/**
 * 从当前页面 hostname 提取子域名
 * - www.tvb.com -> www
 * - programme.tvb.com -> programme
 * - qa-www.tvb.com -> www (移除 qa- 前缀)
 * - qa-programme.tvb.com -> programme (移除 qa- 前缀)
 * @returns {string} 子域名，默认返回 'www'
 */
export function getSubdomain() {
  const hostname = window.location.hostname
  // 移除 qa- 前缀（QA 环境）
  const cleanHostname = hostname.replace(/^qa-/, '')
  // 移除 .tvb.com 后缀，提取子域名
  const subdomain = cleanHostname.replace(/\.tvb\.com$/, '')
  return subdomain || 'www'
}

/**
 * 构造符合 video_ad.md 规范的 Instream 广告 Ad Tag URL
 * @param {Object} options
 * @param {string} options.adUnitPrefix - 广告单元前缀，如 /7299/programme.pc.web.prod
 * @param {string} options.adChildUnit - 子广告单元，如 pr 或 mr
 * @param {string} options.adSize - 广告尺寸，如 1920x1080v 或 1024x768v
 * @param {Object} options.customParams - 自定义参数对象
 * @returns {string} 完整的 Ad Tag URL
 */
export function buildInstreamAdTagUrl({
  adUnitPrefix,
  adChildUnit,
  adSize,
  customParams = {},
  videoDuration = 0
}) {
  const adUnit = `${adUnitPrefix}/content/${customParams.video_id}/video`
  const pageUrl = encodeURIComponent(window.location.href)
  const correlator = Date.now()
  const hdid = localStorage.uuid ? sha256(localStorage.uuid).toString() : ''
  const custParams = encodeURIComponent(
    Object.entries({ hdid, subdomain: getSubdomain(), ...customParams })
      .map(([k, v]) => `${k}=${v}`)
      .join('&')
  )
  // vid_d 为视频时长（秒），顶层查询参数，GAM 依据此参数返回 mid-roll 广告
  const vidD = videoDuration > 0 ? `&vid_d=${videoDuration}` : ''
  return [
    'https://securepubads.g.doubleclick.net/gampad/ads',
    '?ad_rule=1',
    `&correlator=${correlator}`,
    `&description_url=${pageUrl}`,
    '&env=vp',
    '&gdfp_req=1',
    `&iu=${adUnit}`,
    '&output=xml_vmap1',
    `&sz=${adSize}`,
    '&unviewed_position_start=1',
    `&url=${pageUrl}`,
    '&plcmt=1',
    '&vpa=auto',
    '&vpmute=0',
    vidD,
    `&ppid=${hdid}`,
    `&cust_params=${custParams}`
  ].join('')
}

/**
 * 从视频URL中提取视频ID
 * - 本地视频文件：提取文件名（mp4, webm, mkv, avi, mov, flv, m3u8, mpd 等）
 * - YouTube 外链：优先提取 watch?v 参数，若不存在则使用完整URL
 * - 其他URL：使用完整URL作为ID
 * @param {string} videoUrl - 视频URL
 * @param {string} fallback - 匹配失败时的回退值
 * @returns {string} 视频文件名或 fallback
 */
export function extractVideoId(videoUrl, fallback = 'x') {
  if (!videoUrl || typeof videoUrl !== 'string') return fallback

  // 1. 本地视频文件：匹配路径中包含视频扩展名的文件名部分
  const localVideoMatch = videoUrl.match(
    /\/([^/?#]+\.(?:mp4|webm|mkv|avi|mov|flv|m3u8|mpd|m4v|3gp|ts))(?:[/?#]|$)/i
  )
  if (localVideoMatch) return localVideoMatch[1]

  // 2. YouTube 外链：优先提取 watch?v 参数
  if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
    try {
      const parsed = new URL(videoUrl)
      const vParam = parsed.searchParams.get('v')
      return vParam || videoUrl
    } catch (e) {
      // URL解析失败时，使用完整URL作为ID
      return videoUrl
    }
  }

  // 3. 其他URL：使用完整URL作为ID
  return videoUrl
}

/**
 * 将当前 URL 中的 utm_* 参数附加到目标 URL（TC-1631）
 * 用于 replaceState 时保留 utm 参数在浏览器地址栏
 * @param {string} targetUrl - 目标 URL（canonical，不含 utm）
 * @returns {string} 附加了 utm 参数的 URL
 */
export function appendUtmParams(targetUrl) {
  if (import.meta.env.SSR || !targetUrl) return targetUrl
  const searchParams = new URLSearchParams(window.location.search)
  const utmEntries = []
  searchParams.forEach((value, key) => {
    // 跳过空值的 utm 参数，避免地址栏出现无实际参数的 '?' 连接符
    if (key.startsWith('utm_') && value) utmEntries.push(`${key}=${encodeURIComponent(value)}`)
  })
  if (utmEntries.length === 0) return targetUrl
  // utm 参数必须位于 hash 之前：先拆出 hash，拼接 query 后再接回，避免 '?xxx' 落入 fragment
  const hashIndex = targetUrl.indexOf('#')
  const hash = hashIndex >= 0 ? targetUrl.slice(hashIndex) : ''
  const baseUrl = hashIndex >= 0 ? targetUrl.slice(0, hashIndex) : targetUrl
  const separator = baseUrl.includes('?') ? '&' : '?'
  return `${baseUrl}${separator}${utmEntries.join('&')}${hash}`
}
